 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"dashboard":"dashboard","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-0c6c4842":"3b58d0a3","chunk-885ff84e":"dc662450","chunk-a96521e8":"4751c695","chunk-12d361b6":"98f9d980","chunk-2d0abc95":"9fb81f12","chunk-2d0b30dd":"81956aa5","chunk-2d0b387d":"81495ffb","chunk-2d0b991f":"b544e1e0","chunk-2d0c1778":"d8679177","chunk-2d0c4bd9":"bc904e33","chunk-2d0c8045":"d8d535a3","chunk-2d0cb7b0":"f823dbf8","chunk-2d0ce7fd":"2344af62","chunk-2d0d32f2":"233987c3","chunk-2d0d3c8f":"aca058e8","chunk-2d0d61b1":"7a595b2a","chunk-2d0dab8e":"150675b3","chunk-2d0e149e":"7de676c1","chunk-2d0e1a0b":"c8679512","chunk-2d0e53a4":"eb022b95","chunk-2d0e8e4f":"fe8d1063","chunk-2d0e9914":"c6ecbd44","chunk-2d20f797":"15fe4561","chunk-2d20ff38":"3d172e57","chunk-2d21390c":"066794b3","chunk-2d216422":"778c63c0","chunk-2d222cbd":"b11eca22","chunk-2f4b4160":"8ca01e21","chunk-40f1f960":"d9ab5887","chunk-4cdd5cd8":"8fa838eb","chunk-552e8a66":"0b011ae1","chunk-5778625f":"5ed30e6a","chunk-2d0ac190":"0b015431","chunk-2d0b3699":"6c3df82e","chunk-2d0c20db":"be2c84ac","chunk-2d0d7483":"c37c70a4","chunk-2d0e19ed":"9ecb3a81","chunk-40c8b01a":"ca45046f","chunk-5590071b":"68d7a10f","chunk-5d386d79":"9582ce5a","chunk-817707ee":"0befee35","chunk-9b72efcc":"4b07ddde","chunk-aa2737a6":"5d0967a8","chunk-b2d4642c":"22d425e8","chunk-d1063f8e":"5a57d8ee","chunk-e2c13bd8":"8513c4d1","chunk-fc54010e":"47b3f89a","dashboard":"a262d38f","pages":"6b521d9b","chunk-47c34c0a":"241a62ba"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0c6c4842":1,"chunk-a96521e8":1,"chunk-12d361b6":1,"chunk-2f4b4160":1,"chunk-40f1f960":1,"chunk-4cdd5cd8":1,"chunk-552e8a66":1,"chunk-5778625f":1,"chunk-40c8b01a":1,"chunk-5590071b":1,"chunk-5d386d79":1,"chunk-817707ee":1,"chunk-9b72efcc":1,"chunk-aa2737a6":1,"chunk-d1063f8e":1,"chunk-e2c13bd8":1,"chunk-fc54010e":1,"pages":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"dashboard":"dashboard","pages":"pages"}[chunkId]||chunkId) + "." + {"chunk-0c6c4842":"bb6640be","chunk-885ff84e":"31d6cfe0","chunk-a96521e8":"efe98fe1","chunk-12d361b6":"4488c35a","chunk-2d0abc95":"31d6cfe0","chunk-2d0b30dd":"31d6cfe0","chunk-2d0b387d":"31d6cfe0","chunk-2d0b991f":"31d6cfe0","chunk-2d0c1778":"31d6cfe0","chunk-2d0c4bd9":"31d6cfe0","chunk-2d0c8045":"31d6cfe0","chunk-2d0cb7b0":"31d6cfe0","chunk-2d0ce7fd":"31d6cfe0","chunk-2d0d32f2":"31d6cfe0","chunk-2d0d3c8f":"31d6cfe0","chunk-2d0d61b1":"31d6cfe0","chunk-2d0dab8e":"31d6cfe0","chunk-2d0e149e":"31d6cfe0","chunk-2d0e1a0b":"31d6cfe0","chunk-2d0e53a4":"31d6cfe0","chunk-2d0e8e4f":"31d6cfe0","chunk-2d0e9914":"31d6cfe0","chunk-2d20f797":"31d6cfe0","chunk-2d20ff38":"31d6cfe0","chunk-2d21390c":"31d6cfe0","chunk-2d216422":"31d6cfe0","chunk-2d222cbd":"31d6cfe0","chunk-2f4b4160":"c1418900","chunk-40f1f960":"5ff97eee","chunk-4cdd5cd8":"f9749c43","chunk-552e8a66":"4488c35a","chunk-5778625f":"394340a1","chunk-2d0ac190":"31d6cfe0","chunk-2d0b3699":"31d6cfe0","chunk-2d0c20db":"31d6cfe0","chunk-2d0d7483":"31d6cfe0","chunk-2d0e19ed":"31d6cfe0","chunk-40c8b01a":"73c8f799","chunk-5590071b":"7257a102","chunk-5d386d79":"7257a102","chunk-817707ee":"4488c35a","chunk-9b72efcc":"d62dfcaf","chunk-aa2737a6":"aa452d29","chunk-b2d4642c":"31d6cfe0","chunk-d1063f8e":"96a655cf","chunk-e2c13bd8":"ea4e2965","chunk-fc54010e":"10162f0a","dashboard":"31d6cfe0","pages":"ce86d8c6","chunk-47c34c0a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
